import { render, staticRenderFns } from "./ModalAjuda.vue?vue&type=template&id=1629a419&"
import script from "./ModalAjuda.vue?vue&type=script&lang=js&"
export * from "./ModalAjuda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports